import { render, staticRenderFns } from "./myinfo1.vue?vue&type=template&id=2fc9f00e"
import script from "./myinfo1.vue?vue&type=script&lang=js"
export * from "./myinfo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports